import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../actions'
import './EnrollmentYearsDropdown.css'
import { Select } from 'antd'

const EnrollmentYearsDropdown = () => {
  const dispatch = useDispatch()
  const enrollmentYears = useSelector(state => state.payment?.enrollmentYears)
  const selectedEnrollmentYear = useSelector(
    state => state.payment?.selectedEnrollmentYear
  )

  const onYearChange = year => {
    dispatch(Actions.createAction(Actions.SELECT_ENROLLMENT_YEAR_VIEW, year))
  }

  return (
    <div className='enrollment-years-dropdown'>
      <Select
        className='enrollment-years-dropdown-select'
        defaultValue={selectedEnrollmentYear}
        value={selectedEnrollmentYear}
        prefix={<i className='icon-calendar' />}
        suffixIcon={<i className='icon-arrow-thin-down arrow-down' />}
        onChange={onYearChange}
        options={enrollmentYears?.map(year => ({
          value: year,
          label: year
        }))}
      />
    </div>
  )
}

export default EnrollmentYearsDropdown
